
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"150","height":"149","viewBox":"0 0 150 149"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"nonzero"}},[_c('path',{attrs:{"fill":"#717B91","d":"M106.633 85.034v42.517H21.599V42.517h42.517V21.259H.34V148.81h127.551V85.034z"}}),_c('path',{attrs:{"fill":"#0093FF","d":"M127.891 0H85.374v21.259h42.517v42.517h21.259V0z"}})])])
          )
        }
      }
    